import type { TSessionsResponse } from "@/types/TSessionsResponse";
import type { TFetchSessionsOptions } from "@/types/TFetchSessionsOptions";
import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

export async function fetchSessions({ page = 1, pageSize = 20, status }: TFetchSessionsOptions = {}): Promise<TSessionsResponse> {
  try {
    let url = `/api/heygen/sessions?page=${page}&page_size=${pageSize}`;
    if (status && status !== "all") {
      url += `&type=${status}`;
    }

    console.log(`[fetchSessions] Fetching from: ${url}`);
    const sessionsResponse = await authenticatedFetchJson<TSessionsResponse>(url);

    if (!sessionsResponse?.data) {
      console.error("[fetchSessions] Invalid response structure:", sessionsResponse);
      throw new Error("Invalid API response: missing data property");
    }

    console.log(`[fetchSessions] Success - received ${sessionsResponse.data.length} sessions`);
    return sessionsResponse;
  } catch (error) {
    console.error("[fetchSessions] Error details:", {
      error,
      message: error instanceof Error ? error.message : 'Unknown error',
      page,
      pageSize,
      status
    });
    throw error;
  }
}
